import lightGallery from "lightgallery";
import lgVideo from "lightgallery/plugins/video";

const videos = [...document.querySelectorAll('.js-video')];

videos.map(video => {
    lightGallery(video, {
        plugins: [lgVideo],
        licenseKey: '36E69817-E4B8-4397-A896-94F904EE212D',
        download: false,
        closable: true,
        showCloseIcon: true,
    });
});
